/*
We only support a limited amount of HTML Entities to reduce bundle size,
feel free to add missing codes.
Full list: https://github.com/mathiasbynens/he/blob/f1e1ccf451c7e88d411db9f07209159e717b52d1/data/decode-map.json
*/
const TABLE: { [key: string]: string } = {
  amp: "\u0026",
  AMP: "\u0026",
  lt: "\u003c",
  LT: "\u003c",
  gt: "\u003e",
  GT: "\u003e",
  nbsp: "\u00a0",
  copy: "\u00A9",
  COPY: "\u00A9",
  reg: "\u00AE",
  REG: "\u00AE"
};

const htmlEntitiesDecode = (str: string): string =>
  str.replace(/&([^;\s]{2,});?/g, (match: string, entity: string) => {
    if (TABLE[entity]) {
      return TABLE[entity];
    }

    if (entity.charAt(0) == "#") {
      let num = 0;

      if (entity.charAt(1).toLowerCase() == "x") {
        num = parseInt(entity.slice(2), 16);
      } else {
        num = parseInt(entity.slice(1), 10);
      }

      if (!isNaN(num) && num >= -32768 && num <= 65535) {
        return String.fromCharCode(num);
      }
    }

    return match;
  });

export default htmlEntitiesDecode;

/*
http://www.w3school.com.cn/tags/html_ref_entities.html
http://www.w3school.com.cn/tags/html_ref_symbols.html
http://www.elizabethcastro.com/html/extras/entities.html
https://www.w3.org/TR/html401/sgml/entities.html
*/
